const buildConsenters = responseData => {
  if (responseData?.authorized_consenters?.length) {
    return responseData.authorized_consenters.map(
      ({ first_nm, last_nm, home_phone, non_member_id }) => ({
        childrenData: {
          componentName: "Consenter",
          firstName: first_nm,
          lastName: last_nm,
          phone_number: home_phone
        },
        key: "selectedData",
        name: "selectedData",
        type: "listItemWrapper",
        title: "",
        selectedData: {
          first_nm,
          last_nm,
          home_phone,
          non_member_id
        },
        childrenType: "consenter"
      })
    );
  }
  return [];
};

export default buildConsenters;
